import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

export const PAYMENT_MODES = ['CASH', 'UPI', 'NET_BANKING', 'BANK_TRANSFER', 'CHEQUE', 'CARD'];

export function TabPanel({ value, index, children }) {
  return value === index ? <Box sx={{ pt: 3 }}>{children}</Box> : null;
}

export function StatCard({ title, value, icon: Icon, gradient, subtitle }) {
  return (
    <Card sx={{ background: gradient, color: 'white', borderRadius: 3, boxShadow: '0 8px 24px rgba(0,0,0,0.10)', height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="body2" sx={{ opacity: 0.92, mb: 0.5 }}>{title}</Typography>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>{value}</Typography>
            {subtitle && <Typography variant="caption" sx={{ opacity: 0.85 }}>{subtitle}</Typography>}
          </Box>
          <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'rgba(255,255,255,0.2)' }}>
            <Icon sx={{ fontSize: 28 }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export function MiniStat({ label, value, color = '#004d40', bg = '#e0f2f1' }) {
  return (
    <Box sx={{ p: 2, borderRadius: 2, bgcolor: bg, borderLeft: `5px solid ${color}`, height: '100%' }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</Typography>
      <Typography variant="h6" sx={{ fontWeight: 800, color, mt: 0.3 }}>{value}</Typography>
    </Box>
  );
}

// Indian-style amount in words, e.g. 132450 -> "One Lakh Thirty Two Thousand Four Hundred Fifty Rupees Only"
const ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
const below100 = (n) => (n < 20 ? ONES[n] : `${TENS[Math.floor(n / 10)]}${n % 10 ? ' ' + ONES[n % 10] : ''}`);
const below1000 = (n) => (n >= 100 ? `${ONES[Math.floor(n / 100)]} Hundred${n % 100 ? ' ' + below100(n % 100) : ''}` : below100(n));
export function amountInWords(value) {
  let n = Math.round(Number(value || 0));
  if (n === 0) return 'Zero Rupees Only';
  const parts = [];
  const crore = Math.floor(n / 10000000); n %= 10000000;
  const lakh = Math.floor(n / 100000); n %= 100000;
  const thousand = Math.floor(n / 1000); n %= 1000;
  if (crore) parts.push(`${below1000(crore)} Crore`);
  if (lakh) parts.push(`${below100(lakh)} Lakh`);
  if (thousand) parts.push(`${below100(thousand)} Thousand`);
  if (n) parts.push(below1000(n));
  return `${parts.join(' ')} Rupees Only`;
}
